import PropTypes from 'prop-types';

import Missing from '~/components/Elements/Missing';

import ItemRenderer from './ItemRenderer';

const shortName = {
  10: 'VA',
  20: 'AM',
  30: 'HY',
};

const BridleCarriage = ({
  type,
  currentStart,
  isPreliminary = true,
  preliminaryEquipment,
  previousStart,
  showTooltip,
  className,
  short,
}) => {
  const dataSource = isPreliminary
    ? preliminaryEquipment || {}
    : currentStart || {};
  const value = dataSource[type];
  const isFirstTime = Boolean(dataSource[`${type}_first`]);
  const previousValue = previousStart != null ? previousStart[type] : undefined;
  const isChanged =
    value != null && previousValue != null && value !== previousValue;

  if (value == null || (currentStart && currentStart.scratched)) {
    return <Missing />;
  }

  return (
    <ItemRenderer
      isFirstTime={isFirstTime}
      changed={isChanged}
      showTooltip={showTooltip}
      previousValue={previousValue}
      className={className}
    >
      {short ? shortName[dataSource[`${type}_id`]] : value}
    </ItemRenderer>
  );
};

BridleCarriage.propTypes = {
  type: PropTypes.oneOf(['bridle', 'carriage']).isRequired,
  currentStart: PropTypes.object,
  isPreliminary: PropTypes.bool,
  preliminaryEquipment: PropTypes.object,
  previousStart: PropTypes.object,
  showTooltip: PropTypes.bool,
  className: PropTypes.string,
};

export default BridleCarriage;
